function ReviewBanner() {
  return (
    <div>
      <div className="reviewBanner">
        <div className="rTextBox">
          <div className="rText">
            <h1>Customers Love Us</h1>
            <article>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </article>
            <div className="reviewPhoto"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewBanner;
